import type { RouteRecordRaw } from 'vue-router';
import { requireTrialType } from '@/routes/guards/orgtype';

export default [
  {
    path: 'onboarding',
    name: 'plg-client-onboarding-checklist',
    component: () => import('./TrialGettingStarted.vue'),
    beforeEnter: [requireTrialType('PLG_TRIAL')],
  },
] satisfies RouteRecordRaw[];
